import styled from 'styled-components';

import { FlexColumn } from '../../components/GlobalStyled/GlobalStyled';

export const Hello = styled.div`
  ${({ theme }) => `
  color: ${theme.colors.brandDarkGrey};
  font-size: 2rem;

  @media screen and (max-width: 1024px) {
    font-size: 1.15rem;
  }
`}
`;
export const Note = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.brandDarkGrey};
    font-size: 1.2rem;

    strong {
      font-weight: 600;
    }

    @media screen and (max-width: 1024px) {
      font-size: 0.9rem;
      font-weight: 300;

      strong {
        font-weight: 400;
      }
    }
  `}
`;
export const TimeOfDay = styled.span`
  ${({ theme }) => `
  color: ${theme.colors.brandBlue};
`}
`;

export const LoadingContainer = styled.div`
  width: 100%;
  margin-top: 100px;
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const ContainerBlock = styled.div`
  display: block;
  width: 100%;
`;

export const CellContainer = styled.div`
  flex: 1;
  padding: 13px;
  border: 1px solid ${({ theme }) => theme.colors.grey400};
  border-radius: 12px;

  margin-right: 1%;
  margin-bottom: 1%;
  box-shadow: #eee 3px 3px 6px;
`;

export const Cell = styled(FlexColumn)`
  justify-content: center;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
  }
`;

export const PresentNumber = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  @media screen and (max-width: 1024px) {
    padding-right: 20px;
  }
`;
export const PresentNumberGreen = styled.div`
  color: #46b35f;
  font-size: 1.4rem;
  font-weight: 700;
  @media screen and (max-width: 1024px) {
    padding-right: 20px;
  }
`;

export const Legend = styled.div`
  ${({ theme }) => `
  @media screen and (max-width: 1024px) {
    flex: 1;
  }
  font-size: 1rem;
  color: ${theme.colors.brandMediumGrey};
  margin-top: .5rem;
  white-space: pre-line;
  line-height: 1.3;
`}
`;

export const Spacer = styled.div`
  margin-top: 1.5rem;
`;

export const ChartHeader = styled.div`
  font-size: 1.5rem;
`;
export const Label = styled.div`
  font-size: 1rem;
  padding: 5px;
  padding-top: 6px;
  padding-right: 10px;
  @media screen and (max-width: 1024px) {
    flex: 1;
  }
`;
export const DatePickerField = styled.div`
  display: flex;
  padding-right: 20px;
`;
export const DatePickerFieldContainer = styled.div`
  display: flex;
`;
export const TitleIcon = styled.img`
  width: 25px;
  margin-right: 12px;
`;

export const LegendIcon = styled.img`
  width: 18px;
  margin-right: 8px;
`;
